import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MenuItem, Select, styled } from '@mui/material';

export const SelectStyled = styled(Select, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'isSmall',
})(({ open, theme, isSmall }) => ({
  width: '100%',
  height: isSmall ? '24px' : '32px',
  border: 'none',
  '&:focus': {
    border: 'none',
  },
  '& fieldset': {
    border: 'none',
  },
  '&:hover': {
    color: theme.palette.colors.highlight,
    '& svg': {
      color: theme.palette.colors.highlight,
    },
    '& .MuiSelect-select': {
      color: theme.palette.colors.highlight,
    },
  },
  '& svg': {
    color: theme.palette.colors.variantOnInfoBackground,
    '&.MuiSelect-iconOpen': {
      color: theme.palette.colors.highlight,
    },
  },

  '& .MuiSelect-select': {
    color: open
      ? theme.palette.colors.highlight
      : theme.palette.colors.variantOnInfoBackground,
    fontWeight: 'bold',
    padding: '0 0 0 8px',
    fontSize: '12px',
    backgroundColor: theme.palette.colors.infoBackground,

    height: isSmall ? '24px' : '32px',
    lineHeight: isSmall ? '24px' : '32px',

    [theme.breakpoints.down('lg')]: {
      backgroundColor: theme.palette.colors.primaryBackground,
    },
  },
  '& .Mui-disabled': {
    WebkitTextFillColor: `${theme.palette.colors.variantOnInfoBackground} !important`,
    '&:hover': {
      WebkitTextFillColor: theme.palette.colors.variantOnInfoBackground,
    },
  },
  '&.Mui-disabled svg': {
    color: theme.palette.colors.infoBackground,
    cursor: 'auto',

    [theme.breakpoints.up('lg')]: {
      color: theme.palette.colors.disabledAndHoverOnInfoBackground,
    },
  },
}));

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  height: '28px',
  paddingLeft: '8px',
  paddingRight: '8px',
  fontSize: '12px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  '& svg': {
    visibility: 'hidden',
  },
  '&:hover': {
    backgroundColor: theme.palette.colors.disabledAndHoverOnInfoBackground,
  },
  '&.Mui-selected': {
    fontWeight: 'bold',

    backgroundColor: theme.palette.colors.infoBackground,
    '&.Mui-focusVisible': { background: theme.palette.colors.infoBackground },
    '& svg': {
      visibility: 'visible',
    },
    '&:hover': {
      backgroundColor: theme.palette.colors.disabledAndHoverOnInfoBackground,
    },
  },
}));

export const CheckIconStyled = styled(FontAwesomeIcon)(() => ({
  visibility: 'hidden',
}));

export const LabelStyled = styled('span')(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  marginBottom: theme.spacing(0.5),
  fontWeight: 'bold',
  '&.Mui-focused': {
    color: theme.palette.colors.mainFocused,
  },
  '&.Mui-disabled': {
    color: theme.palette.colors.secondaryDisabledText,
  },
}));
